import { AGGREGATED_FIELD_STATE } from '../../../../store/products/helpers/aggregatedFieldState';

export const mapAggregatedKeywordsToList = (field) => {
  if (!field || field.state === AGGREGATED_FIELD_STATE.NOT_APPLICABLE) {
    return { keywords: [], isMultiple: false };
  }

  if (field.state === AGGREGATED_FIELD_STATE.MULTIPLE) {
    return { keywords: [], isMultiple: true };
  }

  if (field.state === AGGREGATED_FIELD_STATE.EMPTY) {
    return { keywords: [], isMultiple: false };
  }

  const keywords = (field.items || []).map((item) => ({
    _id: item._id,
    title: item.label,
  }));

  return { keywords, isMultiple: false };
};

export default mapAggregatedKeywordsToList;
